






import {Component, Vue} from 'vue-property-decorator';
import ShadowBox from '@/components/ShadowBox.vue';

/**
 * provides device-safe spacing at the bottom of the app
 */
@Component({
	components: {
		ShadowBox,
	}
})
export default class AppFooter extends Vue {}
